export const constants = Object.freeze({
  defaultTZ: 'Europe/London',

  minimumSelectableDate: {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate(),
  },

  timeDropdownOptions: [
    { title: '00:00', value: '00:00' },
    { title: '00:30', value: '00:30' },
    { title: '01:00', value: '1:00' },
    { title: '01:30', value: '1:30' },
    { title: '02:00', value: '2:00' },
    { title: '02:30', value: '2:30' },
    { title: '03:00', value: '3:00' },
    { title: '03:30', value: '3:30' },
    { title: '04:00', value: '4:00' },
    { title: '04:30', value: '4:30' },
    { title: '05:00', value: '5:00' },
    { title: '05:30', value: '5:30' },
    { title: '06:00', value: '6:00' },
    { title: '06:30', value: '6:30' },
    { title: '07:00', value: '7:00' },
    { title: '07:30', value: '7:30' },
    { title: '08:00', value: '8:00' },
    { title: '08:30', value: '8:30' },
    { title: '09:00', value: '9:00' },
    { title: '09:30', value: '9:30' },
    { title: '10:00', value: '10:00' },
    { title: '10:30', value: '10:30' },
    { title: '11:00', value: '11:00' },
    { title: '11:30', value: '11:30' },
    { title: '12:00', value: '12:00' },
    { title: '12:30', value: '12:30' },
    { title: '13:00', value: '13:00' },
    { title: '13:30', value: '13:30' },
    { title: '14:00', value: '14:00' },
    { title: '14:30', value: '14:30' },
    { title: '15:00', value: '15:00' },
    { title: '15:30', value: '15:30' },
    { title: '16:00', value: '16:00' },
    { title: '16:30', value: '16:30' },
    { title: '17:00', value: '17:00' },
    { title: '17:30', value: '17:30' },
    { title: '18:00', value: '18:00' },
    { title: '18:30', value: '18:30' },
    { title: '19:00', value: '19:00' },
    { title: '19:30', value: '19:30' },
    { title: '20:00', value: '20:00' },
    { title: '20:30', value: '20:30' },
    { title: '21:00', value: '21:00' },
    { title: '21:30', value: '21:30' },
    { title: '22:00', value: '22:00' },
    { title: '22:30', value: '22:30' },
    { title: '23:00', value: '23:00' },
    { title: '23:30', value: '23:30' },
  ],
});
